import {FETCH_TOKENINSTANCE, FETCH_REVOKEINSTANCE} from "./types";
import axios from "axios";
import 'babel-polyfill';

var qs = require("querystring");
var verifier = localStorage.getItem("verifier");


/*TODO CONSENT*/
export const tokenInstance = (grant_type, authCode) => async dispatch => {

    const tokenParams = {
        "client_id": window.env.OAUTHCLIENTID,
        "grant_type": grant_type,
        "redirect_uri": window.env.REDIRECT_URI,
        "code_verifier": verifier
    }
    var code_type = "code";
    if (grant_type === "refresh_token") {
        code_type = "refresh_token"
        delete tokenParams['code_verifier'];
    }
    delete axios.defaults.headers.common["Authorization"];
    delete axios.defaults.headers.common["Accept"];
    axios.defaults.headers.post["Content-Type"] = 'application/x-www-form-urlencoded';
    tokenParams[code_type] = authCode;
    const res = await axios.post(window.env.TOKEN_URL, qs.stringify(tokenParams));
    dispatch({type: FETCH_TOKENINSTANCE, payload: res.data});
};


export const logoutInstance = () => async dispatch=>{
    var authToken = JSON.parse(sessionStorage.getItem("loginDetails"))

    let data = {
        token: authToken.access_token,
        token_type_hint: "access_token",
        client_id: window.env.OAUTHCLIENTID
    };
    const res = await axios.post(window.env.REVOKE_URL,qs.stringify(data),{headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Accept": "application/x-www-form-urlencoded",
        }})
    dispatch({type:FETCH_REVOKEINSTANCE,payload:res.data})
}

